import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";

import { LeftAlignedGrid, RightAlignedGrid, DateText } from "./sharedStyles";

const AggregateInterestResult = ({ result }) => (
  <>

    <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Aggregate Interest</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.aggregateInterest, 2, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Interest Paid</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.interestPaid, 2, "-")}</RightAlignedGrid>
  </>
);
export default AggregateInterestResult;
